module.exports = __webpack_public_path__ + "img/202311_04.d381b548.jpg";